export const favoriteSessionsArray = [
  {
    title: 'Financial Domination',
    description: 'Tribute. Obey. Repeat. I’m the superior who bleeds your wallet and your will.',
    image: '/images/findom.jpg',
  },
  {
    title: 'Sadistic Mindfuck & Humiliation',
    description: 'Intense degradation, manipulation, and mental control. I’ll ruin you with a smile.',
    image: '/images/mindfuck-humiliation.jpg',
  },
  {
    title: 'Body Worhship',
    description: 'Explore me with body worship, ass worship or foot worship.',
    image: '/images/pegging.jpg',
  },
  {
    title: 'CBT & SPH',
    description: 'Crush your ego and your cock under my cruel delight. Pain is your devotion.',
    image: '/images/cbt-sph.jpg',
  },
  {
    title: 'CNC / TPE / Ownership',
    description: 'Consensual non-consent, total control, and complete surrender. Know your place.',
    image: '/images/cnc-tpe.jpg',
  },
  {
    title: 'Tease, Denial & Ignoring',
    description: 'Get close but never touch. Be tormented by a God who couldn’t care less.',
    image: '/images/tease-denial.jpg',
  },
];


export const offeringsArray = [
  { label: 'Findom / Financial Domination' },
  { label: 'Femdom' },
  { label: 'BDSM' },
  { label: 'Sexting / Texting' },
  { label: 'Voice Calls / Voice Replies' },
  { label: 'Video Calls / Video Replies' },
  { label: 'Custom Content (Pictures, Videos, Clips)' },
  { label: 'Pegging / Strap-On' },
  { label: 'Cock Play (CEI, JOI, Edging, Ruined orgasm)' },
  { label: 'SPH (Small Penis Humiliation)' },
  { label: 'CBT (Cock and Ball Torture)' },
  { label: 'Body Worship' },
  { label: 'Foot Worship' },
  { label: 'Ass Worship' },
  { label: 'Impact Play' },
  { label: 'Humiliation (Light & Heavy)' },
  { label: 'Ignore' },
  { label: 'Tease and Denial' },
  { label: 'Degrading' },
  { label: 'Debt Contracts' },
  { label: 'BNWO (Black New World Order)' },
  { label: 'Forced Intoxication (Controlled)' },
  { label: 'Cuckold' },
  { label: 'Lip Fetish' },
  { label: 'Mindfuck' },
  { label: 'Total Power Exchange (TPE)' },
  { label: 'Feminization' },
];

export const exclusionsArray = [
  { label: 'No mutual masturbation or anything related' },
  { label: 'No scat' },
  { label: 'No blood' },
  { label: 'No needles' },
  { label: 'No blackmail (BM, only BM Fantasy)' },
  { label: 'No race play (excluding BNWO)' },
  { label: 'No age play' },
  { label: 'No vomit' },
  { label: 'No bestiality' },
  { label: 'No incest' },
  { label: 'No gun play' },
  { label: 'No illegal acts' },
];
